// Réglages simples du site, modifiables sans toucher au reste du code.
// Une valeur vide = information pas encore disponible : elle apparaît « à compléter » sur les pages légales
// (ou l'élément correspondant est masqué).

// Adresse de contact (pages légales, demande de suppression de compte).
export const CONTACT_EMAIL = "contact@sideb-app.com";

// Nom de domaine définitif du site, sans https:// (ex. "side-b.fr").
export const SITE_DOMAIN = "sideb-app.com";

// Délai annoncé pour la suppression des données personnelles (en jours).
export const DATA_DELETION_DAYS = 30;

// Lien du compte Instagram (bouton du pied de page). Si on le vide, le bouton disparaît.
export const INSTAGRAM_URL = "https://www.instagram.com/sideb.fi/";

// Mesure d'audience et publicité : chargées UNIQUEMENT après accord dans le bandeau cookies.
// Tant que l'identifiant est vide, l'outil n'est jamais chargé.
export const GA_MEASUREMENT_ID = ""; // Google Analytics 4, ex. "G-XXXXXXXXXX"
export const META_PIXEL_ID = ""; // Meta Pixel, ex. "123456789012345"
// Tant qu'aucun des deux n'est renseigné, le site ne dépose que des cookies nécessaires :
// pas de bandeau cookies, pas de lien « Gérer les cookies », et les pages légales le disent.
export const HAS_TRACKERS = Boolean(GA_MEASUREMENT_ID || META_PIXEL_ID);

// Médiateur de la consommation (CGV, article 14). Laisser vide tant que l'adhésion n'est pas faite.
export const MEDIATOR = { name: "", address: "", website: "" };

// Éditeur et hébergeur (mentions légales)
export const PUBLISHER = {
  name: "Eitan Zibi",
  brand: "Side B",
  status: "entrepreneur individuel (micro-entreprise)",
  address: "173 rue de Courcelles, 75017 Paris, France",
  siret: "882 766 991 00013",
  vat: "TVA non applicable, article 293 B du Code général des impôts",
  director: "Eitan Zibi",
};
export const HOSTING = {
  name: "Emergent AI",
  nameToConfirm: false, // passer à true pour afficher « à compléter » à côté du nom
  address: "255 California Street, Suite 550, San Francisco, CA 94111, États-Unis",
  website: "emergent.sh",
};

// Date de dernière mise à jour des pages légales
export const LEGAL_UPDATED_AT = "20 octobre 2026";
